// Fachada do domínio Sales — métodos da instância (ver core.ts).
import { salesService } from './core';

export const registerCardSaleFromProposal = salesService.registerCardSaleFromProposal;
export const moveWonCardToLastStage       = salesService.moveWonCardToLastStage;

export type { RegisterCardSaleParams, SaleRpcResult } from '@modules/sales';
